<div class="screen-container text-light text-center pt-5">
    <h1 class="display-3"><strong>#404 </strong><br> Page Not Found</h1>
    <h5>If you are looking for the lesson room please check if the link is correct</h5>
</div>
